import { useMemo } from "react";
import client from "libs/client";

export function useTeamGroupFilterOptions() {
	const { data: discoverTeamOptionsResponse, isLoading } = client.getTeamGroupDiscoverTeamOptions.useQuery({
		retry: false,
	});

	const discoverTeamOptions = useMemo(
		() =>
			(discoverTeamOptionsResponse?.data?.teams ?? []).map((option) => ({
				label: option.label ?? "",
				value: String(option.value),
			})),
		[discoverTeamOptionsResponse],
	);

	const discoverClubOptions = useMemo(
		() =>
			(discoverTeamOptionsResponse?.data?.clubs ?? []).map((option) => ({
				label: option.label ?? "",
				value: String(option.value),
			})),
		[discoverTeamOptionsResponse],
	);

	const dynamicOptions = useMemo(
		() => ({
			teamId: discoverTeamOptions,
		}),
		[discoverTeamOptions],
	);

	return {
		dynamicOptions,
		discoverClubOptions,
		discoverTeamOptions,
		isLoading,
	};
}

export function useTeamGroupFormOptions() {
	const { dynamicOptions, discoverClubOptions, discoverTeamOptions, isLoading } = useTeamGroupFilterOptions();

	return {
		discoverClubOptions,
		discoverTeamOptions,
		dynamicOptions,
		isLoading,
	};
}
